import { useDispatch, useSelector } from 'react-redux';
import style from './game-shop-login.module.scss';
import { logout, openLoginPopup } from '../../../redux/actions';
import { getPoints } from '../../../utils/getPoints';

export const GameShopLogin = () => {
  const dispatch = useDispatch();
  const shopStatus = useSelector((state) => state.game.gameShop.settings?.status);
  const wheelStatus = useSelector((state) => state.game.gameWheel.settings?.status);
  const isLogin = useSelector((state) => state.user.isLogin);
  const points = useSelector((state) => state.user.points);
  const username = useSelector((state) => state.user.username);
  const lang = useSelector(state => state.app.currentLang);
  const langName = useSelector(state => state.app.currentLangName)
  if (shopStatus === 'archived') return <></>;
  return (
    <div className={style['game-shop-login__container' + (isLogin ? '_active' : '')]}>
      {isLogin
        ? <>
          <div className={style['game-shop-login__body']}>
            <div className={style['game-shop-login__field']}>
              {username}
            </div>
            <div className={style['game-shop-login__exit']} onClick={() => { dispatch(logout()) }}>
              <div className={style['game-shop-login__exit-icon']} onClick={() => { dispatch(logout()) }} />
            </div>
          </div>
           <p className={style['game-shop-login__points']}>
            {lang.shop.login.text1 + ' '}<b>{points}</b>{' ' + getPoints(langName, points) + (points !== 0 ? (lang.shop.login.text2 + ((wheelStatus === 'active') ? " "+lang.shop.login.text3 : '.')) : '')}
          </p>
        </>

        :
        <div className={style['game-shop-login__body']}>
          <button className={style['game-shop-login__button']} onClick={() => dispatch(openLoginPopup())}>
            {lang.shop.login.title}
          </button>
        </div>
      }
    </div>
  )
}